export default __webpack_public_path__ + "static/media/purpes 1.517a22a8.png";